export const ORG_LINE1 = '';
export const ORG_LINE2 = 'लोकनेते गोपीनाथ मुंढे ऊसतोड कामगार नोंदणी व्यवस्थापन प्रणाली';
export const PHOTO_PATH = '/images/gopinath-munde.jpg';
